(function () {
    'use strict';

    angular
     .module('surveyCampaignsModule')
     .controller('SurveyCampaignComponentListEditController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'businessUnit', 'questionnaireTemplate', 'questionnaireSection',
        'campaign', 'oddSurveyQuestionnaireTemplateService', 'notificationService'];

    function Controller($scope, $state, topBarService, businessUnit, questionnaireTemplate, questionnaireSection,
                        campaign, oddSurveyQuestionnaireTemplateService, notificationService) {

        topBarService.setTitleAndIcon('Survey | ' + businessUnit.TitleEN, 'icon icon-clipboard');
        $scope.questionnaireTemplate = questionnaireTemplate;
        $scope.questionnaireSection = questionnaireSection;
        $scope.campaign = campaign;

        // Go To Survey Campaign
        $scope.goToSurveyCampaign = function () {
            $state.go('odd.surveyCampaignEdit', {
                ODDCampaignID: campaign.ODDCampaignID
            }, {
                reload: true
            });
        };

        // Go To Survey Campaign Section
        $scope.goToSurveySection = function () {
            $state.go('odd.surveyCampaignEdit.section', {
                ODDSectionID: questionnaireSection.ODDSectionID,
                ODDQuestionnaireID: questionnaireTemplate.ODDQuestionnaireID
            }, {
                reload: true
            });
        };

        // Go to Survey Campaigns
        $scope.goToCampaigns = function () {
            $state.go('odd.surveyCampaigns', {
                ODDBusinessUnitID: $scope.campaign.ODDBusinessUnitID
            }, {
                reload: true
            });
        };

        // Delete StaticText
        $scope.deleteStaticText = function (staticText) {

            oddSurveyQuestionnaireTemplateService
             .deleteStaticText($scope.campaign.ODDBusinessUnitID,
              questionnaireSection.ODDQuestionnaireID,
              questionnaireSection.ODDSectionID,
              staticText.ODDStaticTextID).then(function () {
                  notificationService.notify('Static Text has been deleted');
                  $state.go('odd.surveyCampaignEdit.section', {
                      ODDQuestionnaireID: questionnaireSection.ODDQuestionnaireID,
                      ODDSectionID: questionnaireSection.ODDSectionID
                  }, {
                      reload: true
                  });
              });
        };

    }
})();